import React from 'react';
import UploadInvoicesForm from '../components/confirming/uploadInvoicesForm';

const ConfirmingInvoices = () => (
  <UploadInvoicesForm />
);
export default ConfirmingInvoices;
